export default {
    appLogin({}, payload) {
        const { fullName, token } = payload
        localStorage.setItem('qbo_loggedUser', fullName)
        localStorage.setItem('qbo_token', token)
    },
    appLogout() {
        localStorage.removeItem('qbo_loggedUser')
        localStorage.removeItem('qbo_token')
    }
}